import React from "react";
import classNames from "classnames";
import PieChart from "./PieChart";
import ChartNavigator from "./ChartNavigator";
import FailureTds from "./FailureTds";
import { UnderlineLink } from "../../Link";

export default function ProductRowInformation({
  product,
  measurement_ids,
  searchParams,
  getMeasurementName,
  onClose
}) {
  return (
    <div className="product_row_information">
      <p className="title">
        {product.name}
        <UnderlineLink className="close_link" onClick={onClose}>
          {I18n.t("close")}
        </UnderlineLink>
      </p>
      <div className="product_test_charts">
        {product.data.filter(d => d.total > 0).map(d => (
          <div
            key={d.measurement_id}
            className={classNames("product_test_chart", "basic-panel", "with-shadow")}
          >
            <PieChart {...d} title={getMeasurementName(d.measurement_id)} showTitle={true} />
            <table className="failure_numbers">
              <tbody>
                <tr>
                  <FailureTds
                    {...d}
                    title={product.name + " | " + getMeasurementName(d.measurement_id)}
                  />
                </tr>
              </tbody>
            </table>
          </div>
        ))}
      </div>
      <ChartNavigator
        product_id={product.id}
        measurement_ids={measurement_ids}
        searchParams={searchParams}
      />
    </div>
  );
}
